module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#instagram",
      toString: function () {
        return this.url;
      }
    }